import {displayPaymentErrorMessage, type OrderService} from '../order';
import {type GatewayConfiguration} from '../../models/GatewayConfiguration';
import {Feature, stopModalLoading} from '../../reducers/environmentReducer';
import {getLocaleText} from '../../util/translation';
import {addButtonListener, defaultOrderFlow} from './peachpay';
import {FeatureFlag} from '../../../../@type/features';
import bacsImageURL from '../../../img/marks/transfer.svg';
import {getErrorString} from '../../../../@shared/ts/error';
import {store} from '../../store';

export function initBacsSupport(orderService: OrderService) {
	if (!Feature.enabled(FeatureFlag.WOOCOMMERCE_BACS_GATEWAY)) {
		return;
	}

	addButtonListener(getBacsMethodConfiguration().gatewayId, async () => {
		const {error: transactionError, result: transaction} = await orderService.startTransaction(getBacsMethodConfiguration().gatewayId);
		if (transactionError || !transaction) {
			const errorMessage = transactionError ? getErrorString(transactionError) : getLocaleText('An unknown error occured while starting the transaction. Please refresh the page and try again.');
			displayPaymentErrorMessage(errorMessage);

			store.dispatch(stopModalLoading());
			return;
		}

		await defaultOrderFlow(orderService, transaction);
	});
}

export function getBacsMethodConfiguration(): GatewayConfiguration {
	return {
		name: getTitle(),
		gatewayId: 'bacs',
		description: getDescription(),
		assets: {
			title: {src: bacsImageURL},
			badge: {src: bacsImageURL},
		},
	};
}

function getTitle(): string {
	return Feature.metadata(FeatureFlag.WOOCOMMERCE_BACS_GATEWAY, 'title') ?? getLocaleText('Wire/Bank Transfer');
}

function getDescription(): string {
	const description = Feature.metadata<string>(FeatureFlag.WOOCOMMERCE_BACS_GATEWAY, 'description') ?? getLocaleText('Payment via Wire/Bank Transfer');
	const instructions = Feature.metadata<string>(FeatureFlag.WOOCOMMERCE_BACS_GATEWAY, 'instructions') ?? '';
	if (instructions) {
		return /* html */ `
			<span>${description}</span>
			</br></br>
			<span>${instructions}</span>
		`;
	}

	return description;
}
